import Walkthrough from '../../../../../App/models/Walkthrough'
import SkillSet from '../../../../../App/models/SkillSet'
import React from 'react'
import WalkthroughHeader from '../../WalkthroughHeader'
import WalkthroughContent from '../../WalkthroughContent'
import WalkthroughBreadcrumb from '../../WalkthroughBreadcrumb'
import useRRWebEvents from '../../../../hooks/useRRWebEvents'

interface Props {
  walkthrough: Walkthrough
  skillSets?: SkillSet[]
  rrwebData?: any
  steps: any[]
}

const InternalViewer: React.FC<Props> = ({ walkthrough, skillSets, steps }) => {
  const chunks = useRRWebEvents(walkthrough)
  return (
    <>
      <WalkthroughBreadcrumb walkthrough={walkthrough} />
      <div className="max-w-7xl flex flex-col m-auto">
        <WalkthroughHeader
          steps={steps}
          walkthrough={walkthrough}
          skillSets={skillSets}
          chunks={chunks}
        />
        <WalkthroughContent walkthrough={walkthrough} />
      </div>
    </>
  )
}

export default InternalViewer
